import React, { useState, useEffect, useCallback } from "react"
import { useParams } from "react-router-dom"
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { ElementEditorWrapper } from "lib/components"
import { supporting_images_data } from "./supporting_images_data"

const { images } = supporting_images_data


export default function SupportingImagesEditor({ }: { }){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Elements } = queryTools.resource.parseQueryForApi("statement.findAll", {})

  const [ elementsAvailable, setElementsAvailable ] = useState<any[]>([])
  const [ selectedElement, setSelectedElement ] = useState<any>(null)
  const [ showEditor, setShowEditor ] = useState<boolean>(false)

  const handleLoaderSelect = (elem:any) => {
    console.log(elem)
    setSelectedElement(elem)
  }

  useEffect(() => {
    const client_id = _Template?.AssignedTo?._id || null
    if( _Elements ) setElementsAvailable(_Elements.filter((elem:any) => elem.element_type === store.element.refstr && (elem.client_id === null || elem.client_id === client_id)))
  },[_Elements])

  return (
    <div className="w-full relative">
      <p>Choose any of the options below to manage rendering of images:</p>
    </div>
  )
}